/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtext_Brew_Label1Inputs */

const vi_richtext_brew_label1 = /** @type {(inputs: Richtext_Brew_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hướng dẫn pha chi tiết`)
};

/**

* @param {Richtext_Brew_Label1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const richtext_brew_label1 = /** @type {((inputs?: Richtext_Brew_Label1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtext_Brew_Label1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_richtext_brew_label1(inputs)
});
export { richtext_brew_label1 as "richText_brew_label" }